<template>
  <v-container fluid>

    <v-row v-if="logedInUserInfo.rol==3" class="mt-16">
    </v-row>
    <v-row>
      <v-col cols="2"></v-col>
      <v-col>
        <div>
          <v-simple-table dense style="width:100%;text-align:center;">
            <template v-slot:default style="text-align:center;">
              <thead>
                <tr>
                  <th colspan="2" style="text-align:center;">
                    Servicios adicionales
                  </th>
                </tr>
              </thead>
              <thead>
                <tr>
                  <th style="text-align:center;">
                    Nombre servicio
                  </th>
                  <th style="text-align:center;">
                    Precio
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in copiaTarifasServicios[3].TARIFA.Servicios_adicionales"
                  :key="index"
                >
                  <td>
                    <div>{{ item.nombre }}</div>
                  </td>
                  <td>
                    <v-text-field
                      @input="actualizarTarifasServiciosAdicionales()"
                      @focus="$event.target.select()"
                      outlined
                      dense
                      v-model="item.precio"
                    ></v-text-field>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-col>
      <v-col cols="2"></v-col>
    </v-row>
  </v-container>
</template>
<script>
import _ from "lodash";
import { mapActions, mapState } from "vuex";
import { FormatoMoneda, FormatoGuia } from "@/Utils/Utils";
export default {
  data() {
    return {
      copiaTarifasServicios: ""
    };
  },
  beforeDestroy() {},
  async mounted() {
    await this.getTarifas();
    this.copiaTarifasServicios = this.tarifasServicios;
  },
  methods: {
    ...mapActions("tarifas", ["getTarifas", "deleteTarifas", "editTarifas", "destroyDescuentos"]),
    actualizarTarifasServiciosAdicionales: _.debounce(async function(data) {
      let objetoTarifa = {
        Id: this.copiaTarifasServicios[3].ID,
        Descripcion: this.copiaTarifasServicios[3].DESCRIPCIÓN,
        Tarifa: this.copiaTarifasServicios[3].TARIFA
      };
      await this.editTarifas(objetoTarifa);
    }, 400)
  },
  computed: {
    ...mapState("tarifas", {
      tarifasServicios: state => state.descuentos
    }),
    ...mapState({
      logedInUserInfo: state => state.sesion.logedInUserInfo
    }),
  }
};
</script>
